export default {
  get_all: { method: "get", url: "api/discricionaria-legal" },
  show: { method: "get", url: "api/discricionaria-legal{/id}" },
  store: { method: "post", url: "api/discricionaria-legal" },
  update: { method: "put", url: "api/discricionaria-legal{/id}" },
  delete: { method: "delete", url: "api/discricionaria-legal{/id}" },
};
